<template>
  <v-layout>
    <filtersMaster ref="filtersMaster" :select="select" :filtersdef="filtros" :options="options" @filter="filter" @loadSelectsData="loadSelectsData" />
    <v-layout column right floating class="fab-container" style="z-index: 1">
      <v-btn color="primary" fab small dark :title="$t('view.commons.report')" :loading="view.action.submit.busy" class="btn_tippy_menu" @click="report">
        <v-icon small>fas fa-file-excel</v-icon>
      </v-btn>
    </v-layout>
  </v-layout>
</template>
<script>
import FiltersMaster from "@/components/datatable/Filters"; /** *******************************/
import tippy from "tippy.js";
import CombosAPI from "@/services/catalogos";

export default {
  name: "FiltersModule"
  , components: { FiltersMaster }
  , data() {
    return {
      init: true
      , view: { action: { submit: { busy: false } } }
      , select: {
        vendor: {
          completeList: []
          , filteredList: []
          , disabled: false
        }
        , status: {
          completeList: []
          , filteredList: []
          , disabled: false
        }
      }
      , filtros: {
        fecha: []
        , se: []
        , seller: []
        , vendor: []
        , campana: []
        , status: []
        , fechaev: []
      }
      , options: [
        {
          code: "fecha"
          , name: this.$t("view.reportes.reporteexclusiones.filters.fecha")
          , icon: "fas fa-calendar-check"
          , type: "date"
          , selected: { ini: "", end: "" }
          , disabled: false
        }
        , {
          code: "se"
          , name: this.$t("view.reportes.reporteexclusiones.filters.se")
          , icon: "fas fa-sort-numeric-down"
          , type: "multinumber"
          , selected: ""
          , disabled: false
        }
        , {
          code: "seller"
          , name: this.$t("view.reportes.reporteexclusiones.filters.seller")
          , icon: "fas fa-sort-numeric-down"
          , type: "multinumber"
          , selected: ""
          , disabled: false
        }
        , {
          code: "vendor"
          , name: this.$t("view.reportes.reporteexclusiones.filters.vendor")
          , icon: "fas fa-hand-holding-usd"
          , type: "select"
          , selected: {}
          , disabled: this.$store.getters.getUserData.tipoUsuario != "ADMINISTRADOR"
        }
        , {
          code: "campana"
          , name: this.$t("view.reportes.reporteexclusiones.filters.campana")
          , icon: "fas fa-bullhorn"
          , type: "multitext"
          , selected: ""
          , disabled: false
        }
        , {
          code: "status"
          , name: this.$t("view.reportes.reporteexclusiones.filters.status")
          , icon: "fas fa-check"
          , type: "select"
          , selected: {}
          , disabled: false
        }
        , {
          code: "fechaev"
          , name: this.$t("view.reportes.reporteexclusiones.filters.fechaev")
          , icon: "fas fa-calendar-check"
          , type: "date"
          , selected: { ini: "", end: "" }
          , disabled: false
        }
      ]
    };
  }
  , created() {
    this.$nextTick(() => tippy(".btn_tippy_menu", { arrow: true, size: "large", animation: "scale", placement: "left" }));
  }
  , methods: {
    filter(filtros) {
      this.$emit("filter", filtros);
    }
    , async loading(status = false) {
      this.view.action.submit.busy = status;
    }
    , async loadSelectsData() {
      if (this.init) {
        this.loadSelectStatus();
        this.loadSelectVendor();
        if (this.select.status.filteredList.length > 0) this.init = false;
      }
    }
    , async loadSelectVendor() {
      const { data: { results: { combo: vendorList } } } = await CombosAPI.get({ option: "vendor" });
      this.select.vendor.filteredList = vendorList || [];
      this.select.vendor.completeList = vendorList || [];
    }
    , async loadSelectStatus() {
      const { data: { results: { combo: statusList } } } = await CombosAPI.get({ option: "statusEXCLUSIONES" });
      this.select.status.filteredList = statusList || [];
      this.select.status.completeList = statusList || [];
    }
    , report() {
      this.$emit("report");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fab-container {
  position: fixed;
  top: 110px;
  right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/reportes/reporteexclusiones/Filters.vue